export default "__VITE_ASSET__G6Nz7tsm__"